// removed by extract-text-webpack-plugin
module.exports = {"tr":"tr-2Nd66"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/table/table-header-row/table-header-row.less
 ** module id = 209
 ** module chunks = 0
 **/